<template>
    <div 
        class="apaympro-container"
        style="
            height: 100vh;
            background: rgb(38, 27, 100);
            color: #ffffff !important;
            align-items: center;
            display: flex;
        "
    >

        <!-- Loader -->
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="bars"
            :opacity="1"
        ></loading>

        <!-- Error Section -->
        <div class="apaympro-wrapper animated fadeIn" v-if="showErrorPage">
            <div class="apaympro-page">
                <div class="apaympro-header">
                    <div class="page-info mt-3 mb-3">
                        <h3
                            style="
                                font-size: 20px;
                                font-weight: normal;
                                margin: 20px auto 0px;
                                width: 80%;
                                line-height: 1.3;
                            "
                        >
                            {{ $t('transaction_paid.text.value') }}
                        </h3>
                    </div>
                    <div class="mt-3">
                        <img
                            src="../assets/refusico.gif"
                            alt="icon page not found - payment page apaym pro"
                            width="200"
                            height="200"
                            style="width: 200px; height: 100%"
                        />

                    </div>
                    <div class="element-wrap element-wrap-for-submit mt-5 mb-5">
                        <a
                            type="button"
                            id="pay-btn"
                            href="https://pay.apaym.com"
                            target="_blank"
                            class="btn btn-outline-danger btn-block"
                        >{{ $t('transaction_paid.apaym.value') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Error Section -->

        <!-- Begin Payement Section -->
        <div 
            class="apaympro-wrapper animated fadeIn container mb-5" 
            style="width: 500px;"
            v-if="!showErrorPage"
        >
            <div class="apaympro-page">

                <div class="body">
                    <form 
                        class="payment-form text-center" 
                        style="
                            padding: 0px !important;
                            background: transparent !important; 
                            box-shadow: none !important;
                        "
                    >

                        <div class="pt-5 mb-5">
                            <img src="../assets/payez-avec-Apaym-02.png" alt="" width="170">
                        </div>
                        
                        <!-- **************************** -->
                        <!-- **************************** -->
                        <!-- ********** Content ********* -->
                        <!-- **************************** -->
                        <!-- **************************** -->
                        <!-- Visa QR -->
                        <div class="checkout__stage">
                            <section>
                                <div class="visa-qr-container">
                                    <div>
                                        <div class="visa-qr-container__header">
                                            <p 
                                                class="instruction mb-4 font-20" 
                                                style="font-weight: 700;"
                                                v-if="!mobileDevice"
                                            >
                                                Scannez le code QR avec l'application APaym 
                                                de votre téléphone pour effectuer le paiement.
                                            </p>

                                            <p 
                                                class="instruction mb-4 font-20" 
                                                style="font-weight: 700;"
                                                v-if="mobileDevice"
                                            >
                                                1. Mettre à jour ici
                                            </p>

                                            <!-- Download or Update -->
                                            <div class="qr__wrapper mb-5 mt-5" v-if="mobileDevice">
                                                <div class="row">
                                                    <div class="col-md-1 col-sm-1 col-xs-1 col-lg-1"></div>
                                                    <div class="col-md-5 col-sm-5 col-xs-5 col-lg-5">
                                                        <a 
                                                            href="https://apps.apple.com/app/id1211381693"
                                                            target="_blank"
                                                        >
                                                            <img 
                                                                src="../assets/img/Logo-App-Store.png" 
                                                                alt="AppStore icon"
                                                                width="220"
                                                            >
                                                        </a>
                                                    </div>
                                                    <div class="col-md-5 col-sm-5 col-xs-5 col-lg-5">
                                                        <a 
                                                            href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan"
                                                            target="_blank"
                                                        >
                                                            <img 
                                                                src="../assets/img/logo-plstore.png" 
                                                                alt="PlayStore icon"
                                                                width="220"
                                                            >
                                                        </a>
                                                    </div>
                                                    <div class="col-md-1 col-sm-1 col-xs-1 col-lg-1"></div>
                                                </div>
                                            </div>
                                            <!-- Download or Update -->

                                            <p 
                                                class="instruction mb-4 font-20" 
                                                style="font-weight: 700;"
                                                v-if="mobileDevice"
                                            >
                                                2. Continuer le paiement ici
                                            </p>
                                        </div>

                                        <a 
                                            class="btn btn-light mb-4 btn-rounded"
                                            :href="urlAPaym" 
                                            v-if="mobileDevice"
                                            style="
                                                color: #261b64;
                                                background: #ffffff;
                                                font-weight: 700;
                                                font-size: medium;
                                            " 
                                        >
                                            Finaliser le paiement
                                        </a>

                                        <div class="qr__wrapper" v-if="!mobileDevice">
                                            <div class="qr__code">
                                                <img
                                                    v-if="qrCodeUri"
                                                    name="qrCodeImage"
                                                    alt="APaym Pro QR Code"
                                                    :src="qrCodeUri"
                                                    id="qrCodeImage"
                                                    style="border-radius: 15px;"
                                                />
                                            </div>
                                        </div>


                                        <!-- Download APaym -->
                                        <div class="qr__wrapper mb-5 mt-5" v-if="!mobileDevice">
                                            <div class="row">

                                                <div class="col-md-12 mb-4">
                                                    <strong class="font-18">
                                                        <!-- {{ $t('download_apaym.value') }} -->
                                                        Téléchargez l'application APaym sur votre téléphone
                                                    </strong>
                                                </div>

                                                <div class="col-md-1 col-sm-1 col-xs-1 col-lg-1"></div>
                                                <div class="col-md-5 col-sm-5 col-xs-5 col-lg-5">
                                                    <a 
                                                        href="https://apps.apple.com/app/id1211381693"
                                                        target="_blank"
                                                    >
                                                        <img 
                                                            src="../assets/img/Logo-App-Store.png" 
                                                            alt="AppStore icon"
                                                            width="220"
                                                        >
                                                    </a>
                                                </div>
                                                <div class="col-md-5 col-sm-5 col-xs-5 col-lg-5">
                                                    <a 
                                                        href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan"
                                                        target="_blank"
                                                    >
                                                        <img 
                                                            src="../assets/img/logo-plstore.png" 
                                                            alt="PlayStore icon"
                                                            width="220"
                                                        >
                                                    </a>
                                                </div>
                                                <div class="col-md-1 col-sm-1 col-xs-1 col-lg-1"></div>
                                            </div>
                                        </div>
                                        <!-- Download APaym -->
                                    </div>
                                </div>
                            </section>
                        </div>
                        <!-- Visa QR -->
                        <!-- **************************** -->
                        <!-- **************************** -->
                        <!-- ********** Content ********* -->
                        <!-- **************************** -->
                        <!-- **************************** -->
                    </form>
                </div>
            </div>
        </div>
        <!-- Begin Payement Section -->

    </div>
</template>


<script src="https://js.pusher.com/7.0/pusher.min.js"></script>
<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    // import json from '../constants/flags.json';
    import { sweetAlert } from "../constants/functions";
    import axios from 'axios';
    import { apiUrl, _reference } from '../constants/config';
    // import { trim } from 'jquery';
    import Multiselect from "vue-multiselect";
    import TopBar from '../components/TopBar' ;
    import FooterItem from '../components/FooterItem';

    export default {
        components: {
            Loading,
            multiselect: Multiselect,
            'top-bar': TopBar,
            'footer-item': FooterItem,
        },
        data() {
            return {
                isLoading: false, fullPage: true,
                qrCodeUri: "", showErrorPage: false,
                url_data: {
                    reference: ""
                },
                mobileDevice: false, urlAPaym: ""
            }
        },
        computed: {
        },
        methods: {

            onCancel() {
                console.log('Loader dismiss') ;
            },

            generateQr(ref) {

                this.isLoading = true ;
                let dataSend = new FormData();
                dataSend.append("reference", ref+"#");
                // dataSend.append("path", "web-app");

                axios.post(apiUrl + "api/paiement-marchand/generer-qr-pay-with-apaym",
                    dataSend
                ).then(response => {

                    // console.log(response) ;
                    this.isLoading = false;

                    if (response.data.code !== "success") {
                        this.showErrorPage = true ;
                        return false;
                    }

                    if (response.data.billId !== this.url_data.reference +"#") {
                        this.showErrorPage = true ;
                        return false;
                    } 

                    this.qrCodeUri = response.data.qrCodeUri ;
                    this.urlAPaym = "https://pay.apaym.com/a/"+response.data.billId+"?a="+response.data.montant+"&c=XOF&m="+response.data.marchand ;

                    let appAndroid = "intent://#Intent;scheme=apaympay;package=weblogy.com.carteabidjan;S.amount="+ response.data.montant +";S.merchant="+ response.data.marchand +";S.reference="+ this.url_data.reference +";end" ;
                    // console.log(appAndroid)
                    let userAgent = navigator.userAgent.toLowerCase();
                    // let androidDevice = userAgent.indexOf("android") > -1;
                    if ( this.mobileDevice ) {
                        // alert(appAndroid)
                        // userAgent.indexOf("android") > -1 ? window.location.href = appAndroid : console.log("iOS device "+ userAgent) ; // this.urlAPaym ;
                        if ( userAgent.indexOf("android") > -1 ) {
                            window.location.href = appAndroid ;
                        } else {
                            console.log("iOS device "+ userAgent);
                        }
                    }

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            isMobile() {
                var check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            },

            
        },
        mounted() {

            console.log(navigator.userAgent.toLowerCase())

            this.mobileDevice = this.isMobile() ;
            
            this.url_data.reference = this.$route.params.reference;
            if (!this.url_data.reference) {
                this.showErrorPage = true ;
                return false;
            }

            this.generateQr(this.url_data.reference);

            // Update screen page with pusher 
            Pusher.logToConsole = false;
            var channel = this.$pusher.subscribe('wby-channel');
            var my = this ;
            var response = function(data) {

                if ( localStorage.getItem("route") == "defaultPage" || localStorage.getItem("route") == "refPage" ) {

                    if ( my.dataFormulaire.montant.toString() !== "" ) {

                        if ( data.type == "QR" ) {
                            my.modePayment = "Visa QR" ;
                        } else if ( data.type == "BICICI" ) {    
                            my.modePayment = my.$t('payment_modal.bicici.value') ;
                        } else {
                            my.modePayment = data.type ;
                        }

                        if ( data.type == "QR" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.modePay = "Visa QR" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;
                                return false;
                            }      

                        } else if ( data.type == "MTN Money" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.modePay = "MTN Money" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;

                            } else if ( (data.responseCode == "529" || data.responseCode == "515" || data.responseCode == "9" || data.responseCode == "100")  && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.isLoadingMomo = false ;
                                my.mtnNOkay = true ;
                                my.mtnOkay = false;
                            }

                        } else if ( data.type == "Orange Money" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {
                                
                                my.modePay = "Orange Money" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;
                                my.modalOrange == true ? my.$refs['openOrangeMoneyModal'].hide() : "";

                            } else if ( data.responseCode !== "SUCCESS" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.isLoadingOrange = false ;
                                my.orangeNOkay = true ;
                                my.orangeOkay = false;
                                my.modalOrange == true ? my.$refs['openOrangeMoneyModal'].hide() : "";
                            }

                        } else if ( data.type == "WAVE" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {
                                
                                my.modePay = "Wave" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.$refs['openWaveModal'].hide();
                                my.showPaymentSection = false;
                                my.formPayment = true ;

                            } else if ( data.responseCode !== "SUCCESS" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.isLoadingWave = false ;
                                my.waveNOkay = true ;
                                my.waveOkay = false ;
                                my.$refs['openWaveModal'].hide();
                            }

                        }  else if ( data.type == "BICICI" ) {

                            if ( data.status == "success" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.modePay = "Cartes Bancaires" ;
                                my.hideRecu = false ;
                                my.dataPage.isDeleg == "3" ? my.doYangoRechargement() : console.log("Call back") ;
                                my.formPayment = true ;
                                my.showPaymentSection = false;
                                my.modalBicici == true ? my.$refs['openBiciciModal'].hide() : "";

                            } else if ( data.responseCode !== "BICICI-SUCCESS" && data.reference == window.localStorage.getItem("_reference_"+ my.dataPage.slug) ) {

                                my.formBicici = false ;
                                my.isBicici = false ;
                                my.cardType = "" ;
                                my.modalBicici == true ? my.$refs['openBiciciModal'].hide() : "";
                            }
                        }
                    }

                } else {
                    console.log("Payment Page") ;
                }
                
            };

            // Écouteur sur les mises à jour des paiements pour checker le statut
            channel.bind('payment-merchant', response);

        },
        watch: {
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
